import type { SearchScenarioId } from 'owa-search-store';
import { action } from 'satcheljs';

/**
 * This action is dispatched when the user takes an action that should start
 * a search session.
 */
export interface START_SEARCH_SESSIONActionMessage {
    actionSource: string | null;
    shouldStartSearch: boolean;
    scenarioId: SearchScenarioId;
}
export const startSearchSession: (
    actionSource: string | null,
    shouldStartSearch: boolean,
    scenarioId: SearchScenarioId
) => START_SEARCH_SESSIONActionMessage = action(
    'START_SEARCH_SESSION',
    (
        actionSource: string | null,
        shouldStartSearch: boolean,
        scenarioId: SearchScenarioId
    ): START_SEARCH_SESSIONActionMessage => ({
        actionSource,
        shouldStartSearch,
        scenarioId,
    })
);
